var _g, _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1678_4908)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 0C1.44772 0 1 0.447716 1 1V23C1 23.5523 1.44772 24 2 24H20C20.5523 24 21 23.5523 21 23V4L17 0H2Z",
    fill: "#E9F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0V4H21L17 0Z",
    fill: "#C2CDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#F14848"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.75746 18V12.1818H5.93928C6.38625 12.1818 6.76125 12.2652 7.06428 12.4318C7.3692 12.5985 7.59931 12.8277 7.75462 13.1193C7.91181 13.4091 7.99041 13.7386 7.99041 14.108C7.99041 14.4811 7.91181 14.8125 7.75462 15.1023C7.59742 15.392 7.36541 15.6203 7.05859 15.7869C6.75178 15.9517 6.37393 16.0341 5.92507 16.0341H4.47905V15.1676H5.78303C6.04439 15.1676 6.2584 15.1222 6.42507 15.0312C6.59174 14.9403 6.71484 14.8153 6.79439 14.6562C6.87583 14.4972 6.91655 14.3144 6.91655 14.108C6.91655 13.9015 6.87583 13.7197 6.79439 13.5625C6.71484 13.4053 6.59079 13.2831 6.42223 13.196C6.25556 13.107 6.0406 13.0625 5.77734 13.0625H4.81143V18H3.75746ZM10.8775 18H8.90589V12.1818H10.9173C11.4949 12.1818 11.9911 12.2983 12.4059 12.5312C12.8226 12.7623 13.1426 13.0947 13.3661 13.5284C13.5896 13.9621 13.7013 14.4811 13.7013 15.0852C13.7013 15.6913 13.5887 16.2121 13.3633 16.6477C13.1398 17.0833 12.8169 17.4176 12.3945 17.6506C11.9741 17.8835 11.4684 18 10.8775 18ZM9.95987 17.0881H10.8263C11.2317 17.0881 11.5697 17.0142 11.8406 16.8665C12.1114 16.7169 12.315 16.4943 12.4513 16.1989C12.5877 15.9015 12.6559 15.5303 12.6559 15.0852C12.6559 14.6402 12.5877 14.2708 12.4513 13.9773C12.315 13.6818 12.1133 13.4612 11.8462 13.3153C11.5811 13.1676 11.2515 13.0938 10.8576 13.0938H9.95987V17.0881ZM14.7028 18V12.1818H18.43V13.0653H15.7567V14.6449H18.1744V15.5284H15.7567V18H14.7028Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1678_4908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.ecbbebf3ea3744dcb688ce273dfbbe24.svg";
export { ForwardRef as ReactComponent };